import { Link as BaseLink } from '@dx-ui/osc-link';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

type LinkColor = keyof typeof colorMap;

type LinkProps = React.ComponentProps<typeof BaseLink> & {
  /** Link color */
  colorTheme?: LinkColor;
};

const colorMap = {
  brand: 'link--brand',
  accent: 'link--accent',
  inherit: 'text-current',
} as const;

export const Link = ({ ref, children, colorTheme = 'brand', ...rest }: LinkProps) => {
  const colorClassName = colorMap[colorTheme] || '';
  return (
    <BaseLink
      ref={ref}
      {...rest}
      anchorClassName={twMerge(cx('link--base inline-block', colorClassName), rest.anchorClassName)}
      className={twMerge('inline-block', rest.className)}
    >
      {children}
    </BaseLink>
  );
};
